import { Space, Typography } from "antd";

const { Text } = Typography;

/**
 * Renders a titled, bulleted list of classification messages inside the image
 * tooltip. Renders nothing when there are no items.
 */
export const ClassificationList = ({
  title,
  items,
}: {
  title: string;
  items: string[];
}) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <>
      <Text strong style={{ color: "#fff" }}>
        {title}
      </Text>
      <ul
        style={{
          margin: 0,
          padding: "8px 0 8px 16px",
          listStyleType: "disc",
        }}
      >
        {items.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </>
  );
};

interface ClassificationTooltipContentProps {
  approvals: string[];
  problems: string[];
}

/**
 * Tooltip body shown over a media image that has been evaluated against
 * RumbleAI's classifications. Lists approved classifications, deviations and
 * a short disclaimer that AI may make mistakes.
 */
export const ClassificationTooltipContent = ({
  approvals,
  problems,
}: ClassificationTooltipContentProps) => (
  <Space orientation="vertical" size={2}>
    <ClassificationList title="Goedgekeurd:" items={approvals} />
    <ClassificationList title="Afwijkingen:" items={problems} />
    <Text style={{ color: "#fff" }}>
      Controle o.b.v. AI-klassificatie. AI kan fouten maken.
    </Text>
  </Space>
);
